import u from "lodash";
import r, { useState as v, useEffect as y } from "react";
import o from "prop-types";
import p from "classnames";
import { d as k } from "../warningPropType-BELHg60q.es.js";
import { u as B } from "../DarkModeProvider-xoZXm3ct.es.js";
import { u as N } from "../ThemeProvider--i7ESlT5.es.js";
import { I as C } from "../Icon-BuIPTPJn.es.js";
import { w as P } from "../withTheme-zx3wTAWo.es.js";
import '../index5.css';const R = "Tabs-default-module__icon___2PjvJ", S = "Tabs-default-module__tab___03I8n", q = "Tabs-default-module__more___6G-3Y", x = "Tabs-default-module__selected___3yOY6", L = "Tabs-default-module__dark___1B24O", M = {
  icon: R,
  "tab-drawer": "Tabs-default-module__tab-drawer___b3CL0",
  "more-container": "Tabs-default-module__more-container___Ii573",
  tab: S,
  more: q,
  "popup-menu": "Tabs-default-module__popup-menu___UBkqz",
  selected: x,
  dark: L,
  "auto-width": "Tabs-default-module__auto-width___nbhwE",
  "popup-tab": "Tabs-default-module__popup-tab___SKUcp"
}, O = "Tabs-compere-module__icon___HmAnS", $ = "Tabs-compere-module__tab___MLQ2I", I = "Tabs-compere-module__more___UBOHb", U = "Tabs-compere-module__selected___vCKkq", W = "Tabs-compere-module__dark___El2xz", z = {
  icon: O,
  "tab-drawer": "Tabs-compere-module__tab-drawer___n5U6F",
  "more-container": "Tabs-compere-module__more-container___yRL0Q",
  tab: $,
  more: I,
  "popup-menu": "Tabs-compere-module__popup-menu___uBXFh",
  selected: U,
  dark: W,
  "auto-width": "Tabs-compere-module__auto-width___jNpAS",
  "popup-tab": "Tabs-compere-module__popup-tab___-RYNB"
}, g = {
  default: M,
  compere: z
}, f = (e) => {
  const [s, n] = v(!1);
  y(() => {
    const a = () => {
      s && n(!1);
    };
    return document.addEventListener("click", a), () => {
      document.removeEventListener("click", a);
    };
  }, [s]);
  const w = (a) => {
    e.onSelect(a), s && n(!1);
  };
  let b = B();
  e.darkBg && (b = e.darkBg);
  let T = N();
  e.theme && (T = e.theme);
  const t = u.get(g, T, g.default), { maxVisibleTabs: _, autoWidthTabs: E } = e, c = _ - 1;
  let l = -1;
  return e.tabs.forEach(({ key: a }, d) => {
    a === e.selected && (l = d);
  }), /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(
    "div",
    {
      className: t["tab-drawer"],
      role: "tablist",
      "aria-label": e.listLabel
    },
    (e.tabs.length === _ ? u.take(e.tabs, _) : u.take(e.tabs, c)).map(({ label: a, disabled: d, key: m, ariaControls: i }, h) => /* @__PURE__ */ r.createElement(
      "button",
      {
        key: m,
        className: p(
          t.tab,
          b && t.dark,
          h === l && t.selected,
          E && t["auto-width"]
        ),
        role: "tab",
        type: "button",
        "aria-selected": h === l,
        "aria-controls": i,
        disabled: d,
        onClick: () => w(m)
      },
      a
    )),
    e.tabs.length > _ && /* @__PURE__ */ r.createElement("div", { className: t["more-container"] }, /* @__PURE__ */ r.createElement(
      "button",
      {
        role: "tab",
        type: "button",
        "aria-haspopup": "true",
        "aria-expanded": s,
        className: p(
          t.tab,
          t.more,
          b && t.dark,
          l >= c && !s && t.selected
        ),
        onClick: (a) => {
          n(!s), a && a.stopPropagation();
        }
      },
      "More",
      /* @__PURE__ */ r.createElement(
        C,
        {
          className: t.icon,
          color: "currentColor",
          size: 16,
          style: {
            lineHeight: "16px",
            verticalAlign: "middle"
          },
          name: s ? "arrow_up" : "arrow_down"
        }
      )
    ), s && /* @__PURE__ */ r.createElement("div", { className: t["popup-menu"] }, u.drop(e.tabs, c).map(
      ({ label: a, disabled: d, key: m }, i) => /* @__PURE__ */ r.createElement(
        "button",
        {
          key: m,
          onClick: () => {
            n(!s), e.onSelect(m);
          },
          className: p(
            t["popup-tab"],
            i + c === l && t.selected
          ),
          role: "tab",
          type: "button",
          "aria-selected": i === l,
          disabled: d
        },
        a
      )
    )))
  ));
};
f.propTypes = {
  /** whether the tabs are set against a dark background;
   * this makes the text lighter so it can be read
   */
  darkBg: k(
    o.bool,
    "Please use DarkModeProvider instead",
    !0
  ),
  /** a label for the list of tabs, used for accessibility
   * purposes but not visible in the component
   */
  listLabel: o.string.isRequired,
  /** an array of tabs */
  tabs: o.arrayOf(
    o.shape({
      key: o.string.isRequired,
      label: o.node.isRequired,
      disabled: o.bool,
      /** unique id of content controlled by tab for accessibility */
      ariaControls: o.string
    }).isRequired
  ),
  /** the maximum amount of tabs to show, any tabs beyond
   * this number will be hidden behind a dropdown
   */
  maxVisibleTabs: o.number,
  /** MinDS theme (internal prop provided by `withTheme`) */
  theme: k(
    o.oneOf(["default", "compere"]),
    "Please use ThemeProvider instead",
    !0
  ),
  /** the tab key which should be selected, i.e. showing content */
  selected: o.string.isRequired,
  /** function to be called when tab selected, takes 1 argument,
   * `tab`, which is the key of the tab being clicked
   */
  onSelect: o.func.isRequired,
  /** Whether tabs should size themselves to fit their content instead of having equal width */
  autoWidthTabs: o.bool
};
f.defaultProps = {
  darkBg: void 0,
  theme: void 0,
  maxVisibleTabs: 4,
  tabs: [],
  autoWidthTabs: !1
};
const G = P(f);
export {
  G as default
};
